import PropTypes from "prop-types"
import MuiAutocomplete from "@mui/material/Autocomplete";
import MuiTextField from "@mui/material/TextField";

export function Autocomplete({
  label,
  options,
  value,
  multiple = false,
  onChange,
  getOptionLabel = (option) => option?.label ?? "",
  isOptionEqualToValue,
  error,
  helperText,
  ...rest
}) {
  return (
    <MuiAutocomplete
      multiple={multiple}
      options={options ?? []}
      value={value}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          label={label}
          variant="outlined"
          error={!!error}
          helperText={helperText}
        />
      )}
      {...rest}
    />
  );
}

Autocomplete.propTypes = {
  error: PropTypes.any,
  getOptionLabel: PropTypes.func,
  helperText: PropTypes.any,
  isOptionEqualToValue: PropTypes.any,
  label: PropTypes.any,
  multiple: PropTypes.bool,
  onChange: PropTypes.any,
  options: PropTypes.array,
  value: PropTypes.any
}
